import { Flex, FlexProps } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

type MobileEntranceProps = {
  onClick: () => void;
} & FlexProps;

export const MobileEntrance = styled(Flex)<MobileEntranceProps>(({ theme }) => ({
  border: `${theme.borderWidth[25]} solid ${theme.color.border.interactiveBase}`,
  borderRadius: theme.borderRadius[100],
  padding: theme.spacing[300]
}));
